<script>
import {
    authComputed
} from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
    components: {},

    computed: {
        ...authComputed,
    },
    mounted: function () {

        // eslint-disable-next-line no-unused-vars
        var menuRef = new MetisMenu('#side-menu')
        var links = document.getElementsByClassName('side-nav-link-ref')
        var matchingMenuItem = null
        for (var i = 0; i < links.length; i++) {
            if (window.location.pathname === links[i].pathname) {
                matchingMenuItem = links[i]
                break
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add('active')
            var parent = matchingMenuItem.parentElement

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add('active')
                const parent2 = parent.parentElement
                if (parent2) {
                    parent2.classList.add('in')
                }
                const parent3 = parent2.parentElement
                if (parent3) {
                    parent3.classList.add('active')
                    var childAnchor = parent3.querySelector('.has-dropdown')
                    if (childAnchor) childAnchor.classList.add('active')
                }

                const parent4 = parent3.parentElement
                if (parent4) parent4.classList.add('in')
                const parent5 = parent4.parentElement
                if (parent5) parent5.classList.add('active')
            }
        }
    },
    methods: {
        validatedRol(e) {            
            if (this.currentUser === null) {
                if (e.includes("*")) {
                    return true;
                } else {
                    return false;
                }
            }

            if (e.includes(this.currentUser.rol) || e.includes("*")) {
                return true;
            } else {
                return false;
            }
        }

    },
}
</script>

<template>
<!--- Sidemenu -->
<div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
        <li class="menu-title">Menu</li>

        <li v-if="validatedRol(['*'])">
            <router-link to="/" aria-expanded="false">
                <i class="fe-home"></i>
                <span>Inicio</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/pagos/add" aria-expanded="false">
                <i class="fe-dollar-sign"></i>
                <span>Cobros</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/pagos4/add" aria-expanded="false">
                <i class="fe-dollar-sign"></i>
                <span>CFDI 4.0</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/contribuyentes/index" aria-expanded="false">
                <i class="fe-users"></i>
                <span>Contribuyentes</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/licencias/" aria-expanded="false">
                <i class="fe-award"></i>
                <span>Licencias</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/facturacion/" aria-expanded="false">
                <i class="fe-send"></i>
                <span>Facturación</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/complemento/" aria-expanded="false">
                <i class="fe-send"></i>
                <span>REP</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <router-link to="/polizas" aria-expanded="false">
                <i class="fe-book-open"></i>
                <span>Polizas</span></router-link>
        </li>
        <li v-if="validatedRol(['*'])">
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
                <i class="fe-server"></i>
                <span>Configuración</span>
                <span class="menu-arrow"></span>
            </a>
            <ul v-if="validatedRol(['*'])" class="nav-second-level" aria-expanded="false">
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/categorias/index" class="side-nav-link-ref">Categorias</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/subcategorias/index" class="side-nav-link-ref">Subcategoria</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/conceptos/index" class="side-nav-link-ref">Conceptos</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/cuentas/index" class="side-nav-link-ref">Cuentas</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/cajas/index" class="side-nav-link-ref">Cajas</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/certificado/index" class="side-nav-link-ref">Certificado Sello Digital</router-link>
                </li>
              <!--  <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/documentos/validacion" class="side-nav-link-ref">Validación de Documentos</router-link>
                </li> -->

            </ul>
        </li>    
        <li v-if="validatedRol(['*'])">
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
                <i class="fe-book"></i>
                <span>Reportes</span>
                <span class="menu-arrow"></span>
            </a>
            <ul v-if="validatedRol(['*'])" class="nav-second-level" aria-expanded="false">
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/categorias" class="side-nav-link-ref">Categorias</router-link>
                </li>                
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/conceptos" class="side-nav-link-ref">Conceptos</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/contribuyenteconceptos" class="side-nav-link-ref">Conceptos Detalle</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/contribuyenteconceptos_s" class="side-nav-link-ref">Concepto Detalle </router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/usuario" class="side-nav-link-ref">Usuario</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/contribuyente" class="side-nav-link-ref">Contribuyente</router-link>
                </li>
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/reportes/diario" class="side-nav-link-ref">Diario</router-link>
                </li>
              

            </ul>
        </li>    


        <!--
        <li v-if="validatedRol(['*'])">
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
                <i class="fe-inbox"></i>
                <span>Tramites</span>
                <span class="menu-arrow"></span>
            </a>
            <ul v-if="validatedRol(['*'])" class="nav-second-level" aria-expanded="false">
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/solicitudCopia/solicituCopia" class="side-nav-link-ref">Solicitudes copias Certificadas</router-link>
                </li>
            </ul>
        </li> -->
        <li v-if="validatedRol(['Administrador','Operador'])">
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
                <i class="fe-settings"></i>
                <span>Configuración</span>
                <span class="menu-arrow"></span>
            </a>
            <ul v-if="validatedRol(['Administrador','Operador'])" class="nav-second-level" aria-expanded="false">
                <li v-if="validatedRol(['Administrador','Operador'])">
                    <router-link tag="a" to="/organismos/organismos" class="side-nav-link-ref">Organismos</router-link>
                </li>
                <li v-if="validatedRol(['Administrador','Operador'])">
                    <router-link tag="a" to="/tipoDocumento/index" class="side-nav-link-ref">Tipo Documentos</router-link>
                </li>
                <li v-if="validatedRol(['Administrador','Operador'])">
                    <router-link tag="a" to="/metadatos/metadatos" class="side-nav-link-ref">Propiedades Documento</router-link>
                </li>
                <li v-if="validatedRol(['Administrador','Operador'])">
                    <router-link tag="a" to="/listas/listas" class="side-nav-link-ref">Listas</router-link>
                </li>

            </ul>
        </li> 

        <li v-if="validatedRol(['*'])">
            <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
                <i class="fe-user"></i>
                <span>Seguridad</span>
                <span class="menu-arrow"></span>
            </a>
            <ul v-if="validatedRol(['*'])" class="nav-second-level" aria-expanded="false">
                <li v-if="validatedRol(['*'])">
                    <router-link tag="a" to="/usuarios/index/" class="side-nav-link-ref">Usuarios</router-link>
                </li>

            </ul>
        </li>

    </ul>
    <div class="clearfix"></div>
</div>
<!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
